<template>
  <div>
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="50%">
            <group-list @selectGroup="selectGroup"></group-list>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialog.visible=false">关闭</el-button>
            </span>
        </el-dialog>
  </div>
</template>

<script>
import groupList from './lapyer/group-list.vue'
export default {
    components:{groupList},
    data(){
        return {
            dialog:{
                visible:false,
                title:'移动分组'
            }
        }
    },
    methods:{
        selectGroup(data){
            console.log(data)
        },
        open(data){
            console.log(data)
            this.dialog.visible = true;
        },
        close(){
            this.dialog.visible = false;
        },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/customer/select-group.vue